export default __webpack_public_path__ + "static/hero-image-mob-cd5c6d22b8fa5a79feda7480c7f8364a.png";